import ContentFilterPage from './ContentFilterPage';
import container from './ContentFilterPage.container';

export default container(ContentFilterPage);
